var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation-bar"},_vm._l((_vm.routes),function(route){return _c('router-link',{key:route.name,attrs:{"to":{ path: route.path }}},[_c('md-button',{staticClass:"md-primary"},[_vm._v(" "+_vm._s(route.title)+" ")])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }